import React, { useState, useEffect } from "react";
import "./PastAppointment.css";
import Select from "react-select";
import { Link, useParams } from "react-router-dom";
import { useApp } from "./../../../AppProvider";
import { useAuth } from "./../../../AuthProvider";
import Prescription from "../../../assets/Prescription.png";
import Pathology from "../../../assets/Pathology Reports.png";
import Hospital from "../../../assets/Hospital Records.png";
import Medical from "../../../assets/Medical Images.png";
import Vaccination from "../../../assets/Vaccination.png";
import MedicalCert from "../../../assets/Medical.png";
import * as utils from "../../../Utils";


function PastAppointment() {
  const { patientsMHR } = useApp();
  const { user } = useAuth();
  const [activeLink, setActiveLink] = useState("");
  const [selectedOption, setSelectedOption] = useState(null);
  const PastAppointment = patientsMHR.filter(mhr =>
    mhr.doctorId === user._id &&
    (mhr.typeOfRecord === "PrescriptionRecord" || mhr.typeOfRecord === "MedicalCertificateRecord")
  );
  const options = [
    { value: "chocolate", label: "Chocolate" },
    { value: "strawberry", label: "Strawberry" },
    { value: "vanilla", label: "Vanilla" }
  ];

  useEffect(() => {
    setActiveLink("records");
  }, []);

  const RecordCard = ({ record }) => {
    const { recordId } = useParams();
    const isActive = record.recordId === recordId;

    const logos = {
      PrescriptionRecord:        Prescription,
      PathologyRecord:           Pathology,
      RadiologyRecord:           Medical,
      VaccinationRecord:         Vaccination,
      HospitalizationRecord:     Hospital,
      MedicalCertificateRecord:  MedicalCert,
    };
    const logo = logos[record.typeOfRecord] || Prescription;

    const isCert = record.typeOfRecord === "MedicalCertificateRecord";

    return (
      <Link
        className={`linkRec records`}
        to={`/DashboardDashboardNavigation/records/${record.recordId}`}
      >
        <div className={`card-one ${isActive ? "active-card" : ""}`}>
          <div className="card-one_header">
            <img src={logo} className="icon-1" alt="reports" />
            <div className={`${isActive ? "jun" : "may-1"}`}>{utils.formatDate(record.dateOfPublish)}</div>
          </div>
          <div className="type-of_records">
            {isCert ? `Medical Certificate` : record.typeOfRecord}
          </div>
          {isCert && record.certificateType && (
            <p className="doctor-text">{record.certificateType}</p>
          )}
          {!isCert && (
            <p className="doctor-text">{record.doctorsNote}</p>
          )}
          <div className="diagnosis-main-container">
            {(record.diagnosis || []).map((item, index) =>
              item ? <p key={index} className="capsule">{item}</p> : null
            )}
          </div>
        </div>
      </Link>
    );
  };

  return (
      <div className="past-container">
          <h1>Past Records</h1>
        <div className="records-dropdown_past">
          {/* <Select
            className="records-dropdown-1"
            options={options}
            value={selectedOption}
            onChange={setSelectedOption}
            placeholder="Select Record"
          /> */}
        </div>
        <div className="card-main_pastAppontment">
          {PastAppointment.map((record, index) => (
            <RecordCard record={record} />
          ))}
        </div>
      </div>
  );
}

export default PastAppointment;
